import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import { Button as BtnPrimary } from "@talentbait/shared-components";

import DraftjsViewer from "./Campaign__Create_DraftjsViewer/Campaign__Create_DraftjsViewer.jsx";
import DraftjsEditor from "./Campaign__Create_DraftjsEditor.jsx";
import ErrorBoundary from "../../../Components/ErrorBoundary.jsx";

//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const BodyWrapper = styled.div`
  width: 100%;
  padding: 0 15px 15px;
`;
const BodyContent = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HTMLEditorWrapper = styled.div`
  margin-right: 5px;
  h1 {
    line-height: 1;
  }
`;

const EditorActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  transition: all 0.2s;
  ${(props) =>
    props.editingTeaser
      ? `
    margin-bottom: 0;
    opacity: 1;
    visibility: visible;
  `
      : `
    margin-bottom: -45px;
    opacity: 0;
    visibility: hidden;
  `};
`;
const EditorUpdateActions = styled.div`
  display: flex;
`;
const CancelButtonWrapper = styled.div`
  margin-right: 12px;
`;

const HTMLEditor = ({ html = "<div>Stellenanzeige</div>", updatePost, editable = true }) => {
  const [jobPostingMarkup, setJobPostingMarkup] = useState(html);
  const [mode, setMode] = useState("view");
  const setEditMode = useCallback(() => editable && setMode("edit"), [setMode, editable]);
  const setViewMode = useCallback(() => setMode("view"), [setMode]);

  useEffect(() => {
    setJobPostingMarkup(html);
  }, [html]);

  const saveEditing = useCallback(
    (event) => {
      event.preventDefault();
      updatePost({ jobPostingMarkup });
      setViewMode();
    },
    [jobPostingMarkup, updatePost, setViewMode]
  );

  const cancelEditing = useCallback(
    (event) => {
      setJobPostingMarkup(html);
      setViewMode();
    },
    [setJobPostingMarkup, setViewMode, html]
  );

  return (
    <BodyWrapper>
      <BodyContent>
        <HTMLEditorWrapper>
          <ErrorBoundary>
            {mode == "edit" && (
              <DraftjsEditor value={jobPostingMarkup} onChange={setJobPostingMarkup} />
            )}
            {mode == "view" && <DraftjsViewer html={jobPostingMarkup} onClick={setEditMode} />}
          </ErrorBoundary>
          <EditorActions editingTeaser={mode == "edit"}>
            <EditorUpdateActions>
              <CancelButtonWrapper>
                <BtnPrimary type="tertiary" variant="outline" onClick={cancelEditing}>
                  Abbrechen
                </BtnPrimary>
              </CancelButtonWrapper>
              <BtnPrimary type="secondary" onClick={saveEditing}>
                Speichern
              </BtnPrimary>
            </EditorUpdateActions>
          </EditorActions>
        </HTMLEditorWrapper>
      </BodyContent>
    </BodyWrapper>
  );
};
export default HTMLEditor;
